module.exports = __webpack_public_path__ + "static/media/coreValues-02.6540f231.svg";